<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter18">
<h1><a id="page_36"></a><a href="#/003toc#ch18">Caribbean Black Bean Soup</a></h1>
<p class="noindent">A soup with tropical influences that will warm you with its spicy flavors, serving black bean soup is also a terrific way to get your family to eat legumes. We like to serve this soup over steamed rice with cornbread on the side.</p>
<p class="noindent"><i>Quick-soak method for beans: Dried beans are typically soaked overnight in cold water, but you can jump-start them by quick soaking. This method works well if you want to use any type of dried beans in your preparations. Cover dried beans with cold water in a large saucepan. Bring to a boil and cook, uncovered, over medium heat for 2 minutes. Remove from the heat, cover the pan, and let the beans soak for 1 hour. Drain the beans and use in any preparation. The beans may be kept refrigerated in an airtight container for up to 3 days. Freeze the cooked beans for up to 2 months.</i></p>
<p class="noindent">2 tablespoons vegetable oil</p>
<p class="noindent">2 large white onions, finely chopped</p>
<p class="noindent">4 cloves garlic, minced</p>
<p class="noindent">2 jalapeño peppers, seeded and finely chopped</p>
<p class="noindent">½ teaspoon ground allspice</p>
<p class="noindent">1 teaspoon ground cumin</p>
<p class="noindent">4 cups presoaked black beans (see savvy)</p>
<p class="noindent">1 bay leaf</p>
<p class="noindent">4 cups vegetable or chicken broth</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">heat the oil in large skillet over medium-high heat.</p>
<p class="noindent">add the onions, garlic, jalapeños, allspice, and cumin and sauté until the onion are softened.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5-to 7-quart slow cooker and add the beans, bay leaf, and broth.</p>
<p class="noindent">cover the slow cooker and cook on high for 3 hours or on low for 6 hours. Season with salt and pepper. Remove the bay leaf before serving.</p>
<p class="noindent">Serves 8–10</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/> bean savvy</p>
<p class="noindent">Although I prefer to soak the beans overnight for this soup, you may substitute four 14- to 15-ounce cans black beans (drained and rinsed), and cook on low for 4 hours instead of the 6 called for.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 024-chapter18.vue?218bce11